





// vendor
import { defineComponent, PropType, computed } from "@vue/composition-api";
// local
import { HTML, FormItem } from "../../ts/types";

export default defineComponent({
	props:{
		config:{
			type:Object as PropType<FormItem<HTML>>,
			required:true
		}
	},
	setup(props){
		const content = computed(() => props.config.settings.content);
		return {
			content
		};
	}
});

